"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MatureCEECountryPolicy_1 = __importDefault(require("./MatureCEECountryPolicy"));
const MatureLATAMCountryPolicy_1 = __importDefault(require("./MatureLATAMCountryPolicy"));
const MatureRestCountryPolicy_1 = __importDefault(require("./MatureRestCountryPolicy"));
const MatureUSCADCountryPolicy_1 = __importDefault(require("./MatureUSCADCountryPolicy"));
const Policy_1 = require("./Policy");
class MatureCountryPolicy extends Policy_1.Policy {
    meets(criteria) {
        return MatureUSCADCountryPolicy_1.default.meets(criteria)
            || MatureCEECountryPolicy_1.default.meets(criteria)
            || MatureLATAMCountryPolicy_1.default.meets(criteria)
            || MatureRestCountryPolicy_1.default.meets(criteria);
    }
}
exports.default = new MatureCountryPolicy();
